<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    :width="800"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="24">
        <a-col :sm="24" :md="12">
          <a-form-model-item label="名称" prop="descript"
            ><a-input v-model="formData.descript" :maxLength="20"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="代码" prop="code"
            ><a-input
              v-model="formData.code"
              :maxLength="20"
              :disabled="modal.type == 'add' ? false : true"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="类型" prop="type">
            <a-select v-model="formData.type" placeholder="请选择" allowClear>
              <a-select-option value="SMS">短信</a-select-option>
              <a-select-option value="EMAIL">邮件</a-select-option>
              <a-select-option value="PUSH">推送</a-select-option>
              <a-select-option value="WECHAT">微信</a-select-option>
              <a-select-option value="ALIPAY">支付宝</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="应用id" prop="appId"
            ><a-input v-model="formData.appId"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="应用Key" prop="appKey"
            ><a-input v-model="formData.appKey"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12"
          ><a-form-model-item label="签名" prop="signature"
            ><a-input v-model="formData.signature"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            class="default"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="应用秘钥  (PrivateKey)"
            style="white-space:auto;"
            prop="appSecret"
            ><a-input v-model="formData.appSecret" type="textarea"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            class="default"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="应用主秘钥  (PublicKey)"
            prop="masterSecret"
            ><a-input v-model="formData.masterSecret" type="textarea"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="服务地址"
            prop="host"
            ><a-input v-model="formData.host"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="端口号" prop="port"
            ><a-input v-model="formData.port"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="备注"
            prop="remark"
            ><a-input v-model="formData.remark" type="textarea"
          /></a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "OptionInfo",
  data() {
    // handler
    let handleHost = (rule, value, callback) => {
      if (this.formData.type == "EMAIL") {
        if (!value) {
          callback("请输入服务地址");
        }
      }
      callback();
    };
    let handlePort = (rule, value, callback) => {
      if (this.formData.type == "EMAIL") {
        if (!value) {
          callback("请输入端口号");
        }
      }
      callback();
    };
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        code: "",
        descript: "",
        type: "",
        appId: "",
        appKey: "",
        appSecret: "",
        masterSecret: "",
        signature: "",
        host: "",
        port: "",
        isHalt: "F",
        remark: ""
      },
      //form rules
      rules: {
        code: [
          {
            required: true,
            message: "请输入代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change"
          }
        ],
        appId: [
          {
            required: true,
            message: "请输入应用id",
            trigger: "change"
          }
        ],
        appKey: [
          {
            required: true,
            message: "请输入应用Key",
            trigger: "change"
          }
        ],
        appSecret: [
          {
            required: true,
            message: "请输入应用秘钥",
            trigger: "change"
          }
        ],
        signature: [
          {
            required: true,
            message: "请输入签名",
            trigger: "change"
          }
        ],
        host: [{ validator: handleHost }],
        port: [{ validator: handlePort }]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加配置" : "编辑配置";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        code: "",
        descript: "",
        type: "",
        appId: "",
        appKey: "",
        appSecret: "",
        masterSecret: "",
        signature: "",
        host: "",
        port: "",
        isHalt: "F",
        remark: ""
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveThirdConfig";
          if (this.modal.type == "edit") {
            action = "modifyThirdConfig";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.default .ant-form-item-label {
  word-break: break-all;
  word-break: normal;
  white-space: pre-wrap;
  line-height: 25px;
}
</style>
